import Icon from '../components/Icon';

const Weather24Colored = Icon(
  'weather-24-colored',
  <>
    <path
      fill="#57BDBE"
      d="M5 8.25a.75.75 0 0 1 0-1.5h6a1.5 1.5 0 0 0 0-3c-.68 0-1.346.47-1.547 1.01a.75.75 0 1 1-1.406-.52C8.482 3.064 9.743 2.25 11 2.25a3 3 0 0 1 0 6z"
    />
    <path
      fill="#57BDBE"
      d="M2.25 11.5c0 .414.336.75.75.75h15.75a3 3 0 0 0 0-6c-1.257 0-2.518.815-2.953 1.99a.75.75 0 1 0 1.406.52c.2-.54.867-1.01 1.547-1.01a1.5 1.5 0 0 1 0 3H3a.75.75 0 0 0-.75.75M4.25 15.5a.75.75 0 0 1 .75-.75h9a3 3 0 0 1 0 6c-1.257 0-2.518-.815-2.953-1.99a.75.75 0 1 1 1.406-.52c.2.54.867 1.01 1.547 1.01a1.5 1.5 0 1 0 0-3H5a.75.75 0 0 1-.75-.75"
    />
  </>
);

export default Weather24Colored;
